import { Injectable } from '@angular/core';
import type { People } from '../interfaces/people';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root'
})
export class PeopleService extends CrudService<People> {
  constructor() {
    super('people');
  }
}
